export default "__VITE_ASSET__BYkCfBoN__"